<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class='bid_item_title'><i class="fa fa-newspaper-o"></i></span>
      <span class='bid_item_title'>Bidding News</span>
      <el-button @click="moreBidNews" class="bid_more" type="text">more<i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </div>
    <div v-for="(nItem,index) in bidNewsArr" :key="index" class="bid_note_item" @click="seeBidNews(nItem.bidsId)">
      <el-row>
        <el-col :span="19">
          <span class="bid_common_item">{{nItem.bidsName}}</span>
        </el-col>
        <el-col :span="5">{{nItem.promTime}}</el-col>
      </el-row>
    </div>
    <div v-show="isNewsPage" class="bid_pagination">
      <el-pagination @current-change="pageTurn" layout=" prev, pager, next" :total="nPageNoSum">
      </el-pagination>
    </div>
  </el-card>
</template>
<script>
import { bidList } from '@/api/enFrontApi/bidding';
export default {
  data() {
    return {
      isNewsPage: false,
      bidNewsArr: [],
      nPageSize: 10,
      nPageNo: 1,
      nPageNoSum: 1
    };
  },
  created() {
    this.initBidNewsData(1, 5, null);
  },
  methods: {
    initBidNewsData(pageNo, pageSize, flag) {
      if (flag) this.isNewsPage = flag;
      else this.isNewsPage = false;
      bidList(pageNo, pageSize, 3).then(res => {
        this.bidNewsArr = [];
        this.nPageNoSum = parseInt(res.data.pageTotal);
        this.bidNewsArr = res.data.list;
      });
    },
    seeBidNews(bidsId) {
      if (bidsId) {
        this.$router.push({
          name: 'iaic2019en/biddingInfo',
          params: {
            bidId: bidsId,
            itemNmae: 'Bidding News'
          }
        });
      }
    },
    moreBidNews() {
      this.$emit('sendBack', 3);
      this.initBidNewsData(1, this.nPageSize, true);
    },
    sizeChangeCtl(val) {
      this.nPageSize = val;
      this.initBidNewsData(this.nPageNo, this.nPageSize, true);
    },
    pageTurn(val) {
      this.nPageNo = val;
      this.initBidNewsData(this.nPageNo, this.nPageSize, true);
    }
  }
};
</script>
<style lang="stylus" scoped>
.bid_note_item {
  height: 28px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/bidding/bidNews.vue